import { render, staticRenderFns } from "./DepartamentoPessoalImportadorSalarios.vue?vue&type=template&id=1946934c"
import script from "./DepartamentoPessoalImportadorSalarios.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalImportadorSalarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports